module.exports = {
      id: "logos:nswvolunteering-cobrand-usage",
      viewBox: "0 0 178.1 106.1",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#logos:nswvolunteering-cobrand-usage",
      toString: function () {
        return this.url;
      }
    }